// Hero Gallery

var SLIDESHOW_DELAY = 4000;

export default angular.module('syHeroGallery', [])
    /**
     * @ngdoc controller
     * @name alert.controller:GalleryController
     * @description
     * Manages each gallery's lifecycle. Tracks the currently visible
     * gallery item and allows a user to move between items.
     */
    // @ngInject
    .controller('GalleryController', function ($timeout) {
        var controller = this;
        var activeItem = null;
        var items = [];
        var isPlaying = false;
        var delay = SLIDESHOW_DELAY;
        var galleryTimeout;
        // Return all available gallery items
        this.getItems = function () {
            return items;
        };
        // Add a new gallery item to the gallery
        // @param item {object} The item to add
        // @param shouldBeActive {boolean} When true this item is to be set as current
        this.addItem = function (item, shouldBeActive) {
            items.push(item);
            if (shouldBeActive === true) {
                controller.setActive(item);
            }
        };
        // Remove the provided item from the gallery
        // @param item {object} The item to remove
        this.removeItem = function (item) {
            items.splice(items.indexOf(item), 1);
        };
        // Set an item as active
        // @param item {object} The item to become active
        this.setActive = function (item) {
            $timeout(function () {
                activeItem = item;
            });
        };
        // Return the currently active item
        this.getActive = function () {
            return activeItem;
        };
        // Return true when the item provided is currently active
        // @param item {object} The item to become active
        this.isActive = function (item) {
            return activeItem === item;
        };
        // Set the next item in the gallery as active
        this.setNextActive = function () {
            var currentIndex = items.indexOf(controller.getActive());
            if (currentIndex < items.length - 1) {
                controller.setActive(items[++currentIndex]);
            }
            else {
                controller.setActive(items[0]);
            }
        };
        // Set the previous item in the gallery as active
        this.setPreviousActive = function () {
            var currentIndex = items.indexOf(controller.getActive());
            if (currentIndex > 0) {
                controller.setActive(items[--currentIndex]);
            }
            else {
                controller.setActive(items[items.length - 1]);
            }
        };
        // Update the current delay period between each item in a
        // playing gallery
        // @param delayTime {int} New delay time in milliseconds
        this.setDelay = function (delayTime) {
            $timeout(function () {
                delay = parseInt(delayTime, 10);
                controller.pause();
                controller.play();
            });
        };
        // Return the current delay time
        this.getDelay = function () {
            return delay;
        };
        // Returns true when the gallery is currently playing
        this.isPlaying = function () {
            return isPlaying;
        };
        // Play the gallery by updating the active item every
        // controller.delay milliseconds
        this.play = function () {
            $timeout(function () {
                isPlaying = true;
                galleryTimeout = setInterval(controller.setNextActive, delay);
            });
        };
        // Pause the gallery
        this.pause = function () {
            $timeout(function () {
                isPlaying = false;
                clearInterval(galleryTimeout);
            });
        };
    })
    /**
     * @ngdoc directive
     * @name syHeroGallery.directive:gallery
     * @restrict A
     * @description
     * Tracks the state of a gallery via a controller
     */
    // @ngInject
    .directive('syGallery', function () {
        return {
            restrict: 'A',
            scope: true,
            controller: 'GalleryController',
            link: function ($scope, $element, attrs, controller) {
                controller.play();
            }
        };
    })
    /**
     * @ngdoc directive
     * @name gallery.directive:galleryDelay
     * @description
     * Configuration directive to set the delay in milliseconds between
     * each gallery item animation
     */
    // @ngInject
    .directive('syGalleryDelay', function () {
        return {
            restrict: 'A',
            require: '^syGallery',
            link: function ($scope, $element, attrs, controller) {
                if (attrs.syGalleryDelay) {
                    controller.setDelay(attrs.syGalleryDelay);
                }
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syHeroGallery.directive:syGalleryToggle
     * @restrict A
     * @description
     * When clicked toggles the play/pause state of the gallery
     */
    // @ngInject
    .directive('syGalleryToggle', function () {
        return {
            restrict: 'A',
            require: '^syGallery',
            link: function ($scope, $element, attrs, controller) {
                $element.on('click', function () {
                    if (controller.isPlaying()) {
                        return controller.pause();
                    }
                    return controller.play();
                });
                $scope.isPlaying = controller.isPlaying;
                $scope.$watch(controller.isPlaying, function (isPlaying) {
                    $element.toggleClass('hero-gallery-control--pause', isPlaying === true);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syHeroGallery.directive:galleryItem
     * @restrict A
     * @description
     * Represents a single gallery item in the current parent gallery.
     * Will initialize and add itself and update it's state when active.
     */
    // @ngInject
    .directive('syGalleryItem', function () {
        return {
            restrict: 'A',
            require: '^syGallery',
            link: function ($scope, $element, attrs, controller) {
                var item = attrs.id;
                controller.addItem(item);
                $scope.$watch(controller.getActive, function (activeItem) {
                    $element.toggleClass('hero-gallery-item--current', item === activeItem);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syHeroGallery.directive:currentGalleryItem
     * @restrict A
     * @description
     * Configuration directive sets the current item as active on $compile
     */
    // @ngInject
    .directive('syCurrentGalleryItem', function () {
        return {
            restrict: 'A',
            require: '^syGallery',
            link: function ($scope, $element, attrs, controller) {
                controller.setActive(attrs.id);
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syHeroGallery.directive:galleryPagination
     * @restrict A
     * @description
     * Gallery Pagination generates a list of pagination items, one for
     * each item in the gallery.
     */
    // @ngInject
    .directive('syGalleryPagination', function () {
        return {
            restrict: 'E',
            require: '^syGallery',
            template:
                '<nav class="pagination hero-gallery-pagination">' +
                    '<ol>' +
                        '<li ng-repeat="item in getItems()" class="navigation-item" ' +
                                'sy-gallery-paginator="{{item}}">' +
                            '<span>Select gallery item {{$index}}</span>' +
                        '</li>' +
                    '</ol>' +
                '</nav>' +
                '<a sy-gallery-toggle class="hero-gallery-control" href="">' +
                    '{{isPlaying() && \'pause\' || \'play\'}}' +
                '</a>',
            link: function ($scope, $element, attrs, controller) {
                $scope.getItems = controller.getItems;
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syHeroGallery.directive:galleryPaginator
     * @restrict A
     * @description
     * Pagination item allows the user to skip to a specific item
     * in the gallery and changes it's state (via class) when active
     */
    // @ngInject
    .directive('syGalleryPaginator', function () {
        return {
            restrict: 'A',
            require: '^syGallery',
            link: function ($scope, $element, attrs, controller) {
                var item = attrs.syGalleryPaginator;
                $element.on('click', function (e) {
                    controller.setActive(item);
                });
                $scope.$watch(controller.getActive, function (activeItem) {
                    $element.toggleClass('navigation-item--current', item === activeItem);
                });
            }
        };
    });
